import { useContext, useState } from "react";
import Table from "./table";
import { Drawer } from "@MASTER";
import { DrawerContext } from "@CONTEXTS";
import useTabs from "./tab-content";
import Filters from "./filters";
import useMultipleTabs from "./tab-content-multiple";

const PreOrder = () => {
  const TabContent = useTabs();
  const MultipleTabContent = useMultipleTabs();
  const drawer = useContext(DrawerContext);
  const [addType, setAddType] = useState(null);

  return (
    <>
      <div className="app-content-header">
        <div style={{ width: "100%", padding: "12px 24px" }}>
          <Filters />
        </div>
      </div>
      <div className="nav-page-content">
        <Table setAddType={setAddType} />
        {drawer.visible && addType === "single" && (
          <Drawer tabs={TabContent} hideFooter />
        )}
        {drawer.visible && addType === "multiple" && (
          <Drawer tabs={MultipleTabContent} hideFooter />
        )}
      </div>
    </>
  );
};

export default PreOrder;
